import React from 'react';

import {
  Badge,
  ButtonStyled,
  Link,
  TextContainer,
  TopContainer,
} from './IAButton.styles';
import { Sparkles } from '../images/Sparkles';
import { useEventTracking } from 'shared/hooks/useEventTracking';

const ICLINIC_ASSIST_AGENDA_URL =
  '/v2/alpha-testing/configuracoes/profissionais/assistente-agendamento/';

export const IAButton = () => {
  const eventTracking = useEventTracking();
  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault();
    eventTracking('button_clicked', {
      application_name: 'iclinic_web',
      application_feature: 'iclinic_assist_agenda',
      platform_source: 'activation',
      button_name: 'schedule_page_beta_button',
      button_type: 'button',
    }).finally(() => {
      window.location.href = ICLINIC_ASSIST_AGENDA_URL;
    });
  };

  return (
    <Link href={ICLINIC_ASSIST_AGENDA_URL} onClick={handleClick}>
      <ButtonStyled type="button">
        <TopContainer>
          <Sparkles />
          <Badge id="beta-badge">Beta</Badge>
        </TopContainer>
        <TextContainer>Iclinic Assist Agenda</TextContainer>
      </ButtonStyled>
    </Link>
  );
};
